export default function Tilt3DSingle() {
	return (
		<iframe
			src='/tilt3d/single/index.html'
			style={{ width: '100%', height: '100vh', border: 'none' }}
		/>
	);
}
